import React from "react";
import { useAuth } from "@/context/AuthContext";

export default function Watermark() {
  const { user } = useAuth();
  if (!user) return null;
  // Stamp each cell with the signed-in member's name + email for deterrence.
  const name = (user.name || "Member").toUpperCase();
  const email = (user.email || "").toLowerCase();
  const line = `THE BOARDROOM · ${name} · ${email}`;
  const cells = Array.from({ length: 40 });
  return (
    <div className="wm-overlay" data-testid="lesson-watermark" aria-hidden>
      <div className="wm-content">
        {cells.map((_, i) => (
          <span key={i}>{line}</span>
        ))}
      </div>
    </div>
  );
}
